import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  CircularProgress,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import {
  DialogHeader,
  VersionFilter,
  FeedbackTable,
  useTemplateFeedback,
} from './TemplateFeedbackDialogComponents';

const TemplateFeedbackDialog = ({ open, template, onClose }) => {
  const [selectedVersion, setSelectedVersion] = useState('all');

  const {
    feedback,
    loading,
    error,
    versions,
    sortBy,
    sortOrder,
    handleSort,
    loadFeedback,
    loadVersions,
  } = useTemplateFeedback(open, template, selectedVersion);

  const handleVersionChange = event => {
    setSelectedVersion(event.target.value);
  };

  const handleRefresh = () => {
    loadFeedback();
    loadVersions();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogHeader
        template={template}
        loading={loading}
        onRefresh={handleRefresh}
        onClose={onClose}
        disableClose={loading}
      />
      <DialogContent>
        <VersionFilter
          selectedVersion={selectedVersion}
          versions={versions}
          feedbackCount={feedback.length}
          onVersionChange={handleVersionChange}
        />

        {loading ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box textAlign="center" py={4}>
            <Typography variant="h6" color="error" gutterBottom>
              Error Loading Feedback
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {error}
            </Typography>
          </Box>
        ) : feedback.length === 0 ? (
          <Box textAlign="center" py={4}>
            <Typography variant="h6" color="text.secondary" gutterBottom>
              No feedback found
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {selectedVersion !== 'all'
                ? `This template version doesn't have any feedback yet.`
                : "This template doesn't have any feedback yet."}
            </Typography>
          </Box>
        ) : (
          <FeedbackTable
            feedback={feedback}
            sortBy={sortBy}
            sortOrder={sortOrder}
            onSort={handleSort}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

TemplateFeedbackDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  template: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

export default TemplateFeedbackDialog;
